var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCakeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.4375 0 0 8.4375 146.266 65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.7 5c-.5-2.6 1.5-5 4.1-5 2.3 0 4.2 1.9 4.2 4.2v5.2c.6 0 1.2-.1 1.8-.1s1.1 0 1.7.1v-5.2c0-2.3 1.9-4.2 4.2-4.2 2.6 0 4.6 2.4 4.2 5l-1.1 6.1c3.9 1.7 6.9 4.7 6.9 8.4v2.3c0 3.1-2 5.7-4.9 7.4-2.9 1.8-6.7 2.8-11 2.8s-8.1-1-11-2.8c-2.8-1.7-4.8-4.3-4.8-7.4v-2.3c0-3.7 2.9-6.7 6.8-8.4zm17.6 6.9 1.3-7.2c.3-1.8-1-3.5-2.9-3.5-1.6 0-2.9 1.3-2.9 2.9v6.6c-.4-.1-.9-.1-1.3-.1-.6 0-1.1-.1-1.7-.1s-1.2 0-1.8.1c-.4 0-.9.1-1.3.1v-6.5c0-1.6-1.3-2.9-2.9-2.9-1.8 0-3.2 1.7-2.8 3.5l1.3 7.2c-4.2 1.6-7 4.4-7 7.6v2.3c0 4.9 6.5 8.9 14.5 8.9s14.5-4 14.5-8.9v-2.3c.1-3.3-2.7-6.1-7-7.7z",
    fill: "#633001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.4 21.8c0 4.9-6.5 8.9-14.5 8.9s-14.5-4-14.5-8.9v-2.3h29.1v2.3z",
    fill: "#fedc90",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 4.8c-.4-1.8 1-3.5 2.8-3.5 1.6 0 2.9 1.3 2.9 2.9v6.6c1-.1 2-.2 3.1-.2 1 0 2 .1 3 .2v-6.6c0-1.6 1.3-2.9 2.9-2.9 1.8 0 3.2 1.7 2.9 3.5l-1.3 7.2c4.2 1.6 7.1 4.4 7.1 7.6 0 4.9-6.5 8.9-14.5 8.9s-14.5-4-14.5-8.9c0-3.2 2.8-6 7-7.6z",
    fill: "#d1884f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#633001",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.8 18.9c0 1.3-.7 2.4-1.6 2.4s-1.6-1.1-1.6-2.4.7-2.4 1.6-2.4 1.6 1.1 1.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.9 18.9c0 1.3-.7 2.4-1.6 2.4s-1.6-1.1-1.6-2.4.7-2.4 1.6-2.4 1.6 1.1 1.6 2.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakeLogo);
export default __webpack_public_path__ + "static/media/cake-logo.c1b82bc14ae2143119f0439336bc6dfc.svg";
export { ForwardRef as ReactComponent };